import { component } from 'picoapp'
import { zelektor, loopify } from '@/lib/utility-functions.js'

export default component((node, ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { submit: submits = [], terms } = zelektor(node)

    /*******************************************************************************************************************************************/
    /* Event Listeners
    /*******************************************************************************************************************************************/
    loopify(submits).forEach(btn => {
        btn.addEventListener('click', e => {
            if (!terms.checked) {
                e.preventDefault()
                ctx.emit('cartTermsPopup:open')
            }
        })
    })

    ctx.on('cartTerms:accepted', () => {
        acceptTerms()
    })


    /*******************************************************************************************************************************************/
    /* Accept Terms
    /*******************************************************************************************************************************************/
    function acceptTerms() {
        terms.checked = true
        loopify(submits)[0].click()
    }
})